import { render, staticRenderFns } from "./ConfirmationBox.vue?vue&type=template&id=755bc132"
import script from "./ConfirmationBox.vue?vue&type=script&lang=ts"
export * from "./ConfirmationBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports